import React, { createContext, useContext, useMemo } from "react";
import { IMessage } from "../../domain/message.interface";
import useChatInteractions from "../../hooks/use-chat-interactions";

export interface ChatContextData {
  messages: IMessage[];
  buttons: string[];
  enabledInput: boolean;
  isTyping: boolean;
  handleChatSubmit: (message: string) => void;
  selectButtons: (buttons: string[]) => void;
  setEnabledInput: (enabled: boolean) => void;
}

export const ChatContext = createContext<ChatContextData>(
  {} as ChatContextData,
);

interface ChatProviderProps {
  children: React.ReactNode;
}

export const ChatProvider = ({ children }: ChatProviderProps) => {
  const {
    messages,
    buttons,
    enabledInput,
    isTyping,
    handleChatSubmit,
    selectButtons,
    setEnabledInput,
  } = useChatInteractions();

  const contextMemo = useMemo(
    () => {
      return {
        messages,
        buttons,
        enabledInput,
        isTyping,
        handleChatSubmit,
        selectButtons,
        setEnabledInput,
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      messages,
      buttons,
      enabledInput,
      isTyping,
      handleChatSubmit,
      selectButtons,
      setEnabledInput,
    ],
  );

  return (
    <ChatContext.Provider value={contextMemo}>{children}</ChatContext.Provider>
  );
};

export function useChatContext(): ChatContextData {
  return useContext(ChatContext);
}
